<template>
  <div id="konfigurator-info">
    <a v-if="!showInfo" @click="onClick">{{ 'Why we need this information' | translate }}</a>
    <div v-if="showInfo" class="konfigurator-info-content">
		<div class="konfigurator-info-close" @click="onClick"></div>
		<h2 v-if="html.nazev">{{ html.nazev }}</h2>
		<div class="konfigurator-info-popis" v-html="html.popis"></div>
    </div>
  </div>
</template>

<script>
import { apiSilex } from '../api'

export default {
  props: {
    krok: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      showInfo: false,
      html: ''
    }
  },
  methods: {
    onClick: function () {
      this.showInfo = !this.showInfo
    }
  },
  mounted: function () {
    apiSilex.get('/krok/' + this.krok).then(response => (this.html = response.data))
  }
}
</script>



// WEBPACK FOOTER //
// Info.vue?7b2a98f0